import React, { type FC, type ReactNode } from "react";

const widthStyles = {
  sm: "w-full max-w-(--breakpoint-sm)",
  md: "w-full max-w-(--breakpoint-lg)",
  lg: "w-full max-w-(--breakpoint-xl)",
  xl: "w-full max-w-(--breakpoint-2xl)",
  "2xl": "w-full max-w-[112rem]",
};

interface ContentContainerProps {
  children: ReactNode;
  size?: keyof typeof widthStyles; // defaults to MD
}

export const ContentContainer: FC<ContentContainerProps> = (props) => {
  const maxWidth = widthStyles[props.size ?? "md"];
  return <div className={`${maxWidth} mx-auto my-8`}>{props.children}</div>;
};
